import { render } from "./ReferralBaseTableRow.vue?vue&type=template&id=5361ceb8"
import script from "./ReferralBaseTableRow.vue?vue&type=script&lang=js"
export * from "./ReferralBaseTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__